<template>
  <div class="home">
    <div class="banner" :style="`background: url(${banner}) center no-repeat;`">
      <!--<el-image :src="bannerImage"></el-image>-->
      <div class="banner_center">
        <div class="banner_title">
          <div class="b_title">泳池建造源头工厂</div>
          <p>泳池一站式服务工厂</p>
          <p>泳池设计/设备供应/安装施工/售后维修</p>
        </div>

        <div class="quote_list">
          <div class="quote_title_box">
            <p>AI正在为您提供：近6个月泳池工厂交易价格。</p>
            <p>免费获取设计方案和报价：</p>
          </div>

          <vue-seamless-scroll :data="quote_list" :classOption="classOption" class="quote_warp">
            <template v-for="(item, i) in quote_list">
              <div class="quote_item" :key="i">
                {{item}}
              </div>
            </template>
          </vue-seamless-scroll>

        </div>

      </div>
    </div>

    <!--关于我们-->
    <div class="about_section" v-if="false">
      <div class="centre-width">
        <div class="about_title t_center">
          <div class="title_cn">关于我们</div>
          <div class="title_en">ABOUT US</div>
        </div>
        <div class="flex-b">
          <div class="about_image">
            <el-image class="img" :src="aboutImage"></el-image>
            <div class="about_logo">
              <el-image class="img" :src="logoImage"></el-image>
            </div>
          </div>
          <div class="about_content">
            <p>

            </p>
            <div class="more_btn">查看更多</div>
          </div>
        </div>
      </div>
    </div>
    <!--关于我们 end-->

    <!--填写信息-->
    <div class="edit_section">
      <div class="edit_tag flex-c-c">
        <div class="tag_item" :class="form_type==1?'on':''" @click="changeType(1)">钢结构泳池</div>
        <div class="tag_item" :class="form_type==2?'on':''" @click="changeType(2)">土建泳池</div>
      </div>
      <div class="centre-width flex-b">
        <!--<div class="kinds_list">-->
        <!--<a class="kinds_item">池体与过滤</a>-->
        <!--<a class="kinds_item">泳池恒温设备</a>-->
        <!--<a class="kinds_item">除湿设备</a>-->
        <!--</div>-->
        <div class="form_section">

          <!--尺寸-->
          <div class="form_item">
            <div class="form_label">尺寸 <span>*</span></div>
            <div class="input_section flex-c">
              <div class="input_item">
                <p>同水平深度</p>
                <div class="input_box m">
                  <input class="input" type="number" v-model="form.deep" placeholder="请输入">
                </div>
              </div>
              <div class="input_item">
                <p>渐变最深处</p>
                <div class="input_box m">
                  <input class="input" type="number" v-model="form.gradient_deep" placeholder="请输入">
                </div>
              </div>
              <div class="input_item">
                <p>长度</p>
                <div class="input_box m">
                  <input class="input" type="number" v-model="form.long" placeholder="请输入">
                </div>
              </div>
              <div class="input_item">
                <p>宽度</p>
                <div class="input_box m">
                  <input class="input" type="number" v-model="form.wide" placeholder="请输入">
                </div>
              </div>
            </div>
          </div>
          <!--尺寸 end-->

          <!--循环方式-->
          <div class="form_item">
            <div class="form_label">循环方式 <span>*</span></div>
            <div class="content_section">
              <radioGroup :value.sync="form.circulate.value"
                          :label.sync="form.circulate.label"
                          :hidden="[]"
                          :disable="false"
                          :list="circulateList">
              </radioGroup>
            </div>
          </div>
          <!--循环方式 end-->

          <!-- 钢材-->
          <div class="form_item" v-if="form_type == 1">
            <div class="form_label"> 钢材</div>
            <div class="content_section">
              <radioGroup :value.sync="form.steels.value"
                          :label.sync="form.steels.label"
                          :hidden="[]"
                          :disable="false"
                          :list="steelsList">
              </radioGroup>
            </div>
          </div>
          <!--钢材 end-->

          <!--胶膜-->
          <div class="form_item" v-if="form_type == 1">
            <div class="form_label">胶膜</div>
            <div class="content_section">
              <div class="section">
                <radioGroup :value.sync="form.coating.spec"
                            :label.sync="form.coating.spec_title"
                            :hidden="[]"
                            :disable="false"
                            :list="specList">
                </radioGroup>
              </div>

              <div class="section mt20">
                <div class="label_title mb10 f14 c_333">品牌：</div>
                <radioGroup :value.sync="form.coating.brand_type"
                            :label.sync="form.coating.brand_title"
                            :hidden="[]"
                            :disable="false"
                            :list="brandList">
                </radioGroup>
              </div>

            </div>
          </div>
          <!--胶膜 end-->

          <!-- 贴砖品牌-->
          <div class="form_item" v-if="form_type == 2">
            <div class="form_label">贴砖品牌</div>
            <div class="content_section">

              <radioGroup :value.sync="form.tz_brand.value"
                          :label.sync="form.tz_brand.label"
                          :hidden="['1']"
                          :disable="false"
                          :list="brandList">
              </radioGroup>

            </div>
          </div>
          <!-- 贴砖品牌 end-->

          <!--管道-->
          <div class="form_item">
            <div class="form_label">管道</div>
            <div class="content_section">
              <div class="input_section flex-c">
                <div class="input_item">
                  <p>机房到泳池水平距离（长度）</p>
                  <div class="input_box m">
                    <input class="input" type="number" v-model="form.piping_long" placeholder="请输入">
                  </div>
                </div>
                <div class="input_item">
                  <p>机房到泳池垂直距离（高度）</p>
                  <div class="input_box m">
                    <input class="input" type="number" v-model="form.piping_high" placeholder="请输入">
                  </div>
                </div>
              </div>

              <div class="section mt20">
                <div class="label_title mb10 f14 c_333">品牌：</div>
                <radioGroup :value.sync="form.piping.brand_type"
                            :label.sync="form.piping.brand_title"
                            :hidden="[]"
                            :disable="false"
                            :list="brandList">
                </radioGroup>
              </div>

            </div>
          </div>
          <!--管道 end-->

          <!--过滤设备-->
          <div id="id1" class="form_item">
            <div class="form_label">过滤设备</div>
            <div class="content_section">
              <template v-for="(item, i) in filterDevice">
                <div :key="i">

                  <!--是否需要过滤设备-->
                  <radioSingle :radioValue="item.value"
                               :radioTitle="item.title"
                               :value.sync="form.filter_device.value"
                               :label.sync="form.filter_device.label"
                               @change="filterDeviceChange">
                  </radioSingle>

                  <div v-if="form.filter_device.value == item.value && item.value == 1" class="pl30">
                    <!--遍历类型-->
                    <template v-for="(son, s) in item.typeList">
                      <div class="mb15">
                        <radioSingle :radioValue="son.value"
                                     :radioTitle="son.title"
                                     :value.sync="form.filter_device_type.value"
                                     :label.sync="form.filter_device_type.label"
                                     @change="filterDeviceTypeChange">
                        </radioSingle>

                        <div class="section flex-c">
                          <span class="label_title f14 c_333">品牌：</span>
                          <!--遍历品牌-->
                          <template v-for="(el, b) in son.brand">
                            <radioSingle :radioValue="el.value"
                                         :radioTitle="el.title"
                                         :disable="son.value != form.filter_device_type.value"
                                         :value.sync="form.filter_type.value"
                                         :label.sync="form.filter_type.label">
                            </radioSingle>
                          </template>
                        </div>
                      </div>
                    </template>
                  </div>

                </div>
              </template>
            </div>
          </div>
          <!--过滤设备 end-->

          <!--消毒设备-->
          <div class="form_item">
            <div class="form_label">消毒设备</div>
            <div class="content_section">
              <template v-for="(item, i) in disinfectDevice">
                <div :key="i">

                  <!--是否需要过滤设备-->
                  <radioSingle :radioValue="item.value"
                               :radioTitle="item.title"
                               :value.sync="form.disinfect_device.value"
                               :label.sync="form.disinfect_device.label"
                               @change="disinfectDeviceChange">
                  </radioSingle>

                  <div v-if="form.disinfect_device.value == item.value && item.value == 1" class="pl30">
                    <!--遍历类型-->
                    <div class="flex-c">
                      <template v-for="(son, s) in item.typeList">
                        <radioSingle :radioValue="son.value"
                                     :radioTitle="son.title"
                                     :value.sync="form.disinfect_device_type.value"
                                     :label.sync="form.disinfect_device_type.label"
                                     @change="disinfectDeviceTypeChange">
                        </radioSingle>
                      </template>
                    </div>
                    <div class="section flex-c">
                      <span class="label_title f14 c_333">品牌：</span>
                      <!--遍历品牌-->
                      <template v-for="(el, b) in item.brand">
                        <radioSingle :radioValue="el.value"
                                     :radioTitle="el.title"
                                     :disable="form.disinfect_device_type.value == 5"
                                     :value.sync="form.disinfect_type.value"
                                     :label.sync="form.disinfect_type.label">
                        </radioSingle>
                      </template>
                    </div>
                  </div>

                </div>
              </template>
            </div>
          </div>
          <!--消毒设备 end-->

          <!-- 泳池恒温设备-->
          <div id="id2" class="form_item">
            <div class="form_label">泳池恒温设备</div>
            <div class="content_section">
              <template v-for="(item, i) in constantDevice">
                <div :key="i">

                  <!--是否需要泳池恒温设备-->
                  <radioSingle :radioValue="item.value"
                               :radioTitle="item.title"
                               :value.sync="form.constant_device.value"
                               :label.sync="form.constant_device.label"
                               @change="constantDeviceChange">
                  </radioSingle>

                  <div v-if="form.constant_device.value == item.value && item.value == 1" class="pl30">
                    <!--遍历类型-->
                    <div class="flex-c">
                      <template v-for="(son, s) in item.typeList">
                        <radioSingle :radioValue="son.value"
                                     :radioTitle="son.title"
                                     :value.sync="form.constant_device_type.value"
                                     :label.sync="form.constant_device_type.label">
                        </radioSingle>
                      </template>
                    </div>
                    <div class="section flex-c">
                      <span class="label_title f14 c_333">地区：</span>
                      <!--遍历所在地区-->
                      <template v-for="(el, b) in item.area">

                        <!--钢结构-->
                        <template v-if="form_type == 1">
                          <radioSingle :radioValue="el.value"
                                       :radioTitle="el.title"
                                       :value.sync="form.constant_device_location.value"
                                       :label.sync="form.constant_device_location.label">
                          </radioSingle>
                        </template>
                        <!--土建-->
                        <template v-if="form_type == 2">
                          <radioSingle :radioValue="el.value" v-if="el.value != 4"
                                       :radioTitle="el.title"
                                       :value.sync="form.constant_device_location.value"
                                       :label.sync="form.constant_device_location.label">
                          </radioSingle>
                        </template>

                      </template>
                    </div>
                    <div class="section flex-c">
                      <span class="label_title f14 c_333">品牌：</span>
                      <!--遍历品牌-->
                      <template v-for="(el, b) in item.brand">
                        <radioSingle :radioValue="el.value"
                                     :radioTitle="el.title"
                                     :value.sync="form.constant_device_brand.value"
                                     :label.sync="form.constant_device_brand.label">
                        </radioSingle>
                      </template>
                    </div>
                  </div>

                </div>
              </template>
            </div>
          </div>
          <!--泳池恒温设备 end-->

          <!-- 除湿设备-->
          <div id="id3" class="form_item">
            <div class="form_label">除湿设备</div>
            <div class="content_section">
              <template v-for="(item, i) in removeWetDevice">
                <div :key="i">

                  <!--是否需要除湿设备-->
                  <radioSingle :radioValue="item.value"
                               :radioTitle="item.title"
                               :value.sync="form.dehumidification_device.value"
                               :label.sync="form.dehumidification_device.label"
                               @change="removeWetDeviceChange(1)">
                  </radioSingle>

                  <div v-if="form.dehumidification_device.value == item.value && item.value == 1" class="pl30">
                    <!--遍历类型-->
                    <div class="flex-c">
                      <template v-for="(son, s) in item.typeList">
                        <radioSingle :radioValue="son.value"
                                     :radioTitle="son.title"
                                     :value.sync="form.dehumidification_device_type.value"
                                     :label.sync="form.dehumidification_device_type.label"
                                     @change="removeWetDeviceChange(2)">
                        </radioSingle>
                      </template>
                    </div>
                    <div class="section flex-c">
                      <span class="label_title f14 c_333">品牌：</span>
                      <!--遍历品牌-->
                      <template v-for="(el, b) in item.brand">
                        <radioSingle :radioValue="el.value"
                                     :radioTitle="el.title"
                                     :disable="!['', '1'].includes(form.dehumidification_device_type.value)"
                                     :value.sync="form.dehumidification_device_brand.value"
                                     :label.sync="form.dehumidification_device_brand.label">
                        </radioSingle>
                      </template>
                    </div>
                  </div>

                </div>
              </template>
            </div>
          </div>
          <!--除湿设备 end-->


          <div class="submit_btn mt60" @click="editContactInfo">立即报价</div>

        </div>

      </div>

    </div>
    <!--填写信息 end-->

    <footerView></footerView>


    <!-- 填写手机号 / 姓名-->
    <el-dialog :visible.sync="editVisible" width="420px" top="0" center
               :close-on-press-escape="false"
               v-loading="submitLoading" element-loading-text="AI正在为您提供近6个月泳池工厂交易价格..."
               :close-on-click-modal="false">
      <div slot="title" class="edit_info_title t_left">
        输入电话号码获取价格
      </div>
      <div>
        <div class="edit_input_box">
          <input class="edit_input" v-model="form.name" type="text" placeholder="请输入姓名">
        </div>
        <div class="edit_input_box">
          <input class="edit_input" v-model="form.mobile" type="text" placeholder="请输入电话号码">
        </div>

        <div class="flex-c">

          <div :class="['disclaimer flex-c', isAgreement?'on':'']" @click="handleAgree">
            我已阅读并同意<span @click.stop="lookDisclaimer">《免责声明》</span>
          </div>
        </div>

        <div class="get_report flex-c-c" @click="submitQuotation">获取报价</div>
      </div>
    </el-dialog>
    <!-- 填写手机号 / 姓名 end-->

    <!-- 免责声明-->
    <el-dialog :visible.sync="disclaimerVisible" width="820px" top="0" center
               :close-on-press-escape="false"
               :close-on-click-modal="false">
      <div slot="title" class="edit_info_title t_left">
        免责声明
      </div>
      <div>
        <div style="max-height: 60vh; overflow-y: scroll" v-html="disclaimerContent"></div>

        <div class="flex-c-c">
          <div class="get_report flex-c-c" style="width: 160px;" @click="handleKnow">我知道了</div>
        </div>

      </div>
    </el-dialog>
    <!-- 免责声明 end-->


    <!-- 报价结果 -->
    <el-dialog class="result_dialog" :visible.sync="resultVisible" width="600px"
               :show-close="false"
               center>
      <div slot="title" class="result_title">
        <div class="result_tips">
          <p>数据为AI搜集统计</p>
          <p>近6个月泳池工厂交易价格均价</p>
        </div>
        <div class="money flex-c">
          费用总计：
          <span>{{ result_price }}</span>
          元
        </div>

        <el-image @click="resultVisible = false" class="close_btn" :src="closeImage"></el-image>
      </div>

      <div class="result_scroll" v-if="result !== ''">

        <div class="price_item">
          <div class="price_list_title flex-c">
            <span>A1</span>
            池体与过滤
          </div>
          <div class="price_list">
            <div class="list_item">
              <div class="price_label">尺寸</div>
              <div>
                <p>· 同水平深度 {{result.deep || '0'}} m</p>
                <p>· 渐变最深处 {{result.gradient_deep || '0'}} m</p>
                <p>· 长度 {{result.long || '0'}} m</p>
                <p>· 宽度 {{result.wide || '0'}} m</p>
              </div>
            </div>
            <div class="list_item">
              <div class="price_label">循环方式</div>
              <div>
                <p>· {{result.circulate.label || '' }}</p>
              </div>
            </div>

            <template v-if="result.type == 1">
              <div class="list_item">
                <div class="price_label">钢材</div>
                <div>
                  <p>· {{result.steels.label || ''}}</p>
                </div>
              </div>
              <div class="list_item">
                <div class="price_label">胶膜</div>
                <div>
                  <p>· {{result.coating.spec_title || ''}}</p>
                  <p>· {{result.coating.brand_title || ''}}</p>
                </div>
              </div>
            </template>

            <template v-if="result.type == 2">
              <div class="list_item">
                <div class="price_label">贴砖品牌</div>
                <div>
                  <p>· {{result.tz_brand.label || ''}}</p>
                </div>
              </div>
            </template>

            <div class="list_item">
              <div class="price_label">管道</div>
              <div>
                <p>· 机房到泳池水平距离（长度） {{result.piping_long || '--'}} m</p>
                <p>· 机房到泳池垂直距离离（高度） {{result.piping_high || '--'}} m</p>
                <p>· {{result.piping.brand_title || ''}}</p>
              </div>
            </div>

            <div class="list_item">
              <div class="price_label">过滤设备</div>
              <div v-if="result.filter_device.value == 1">
                <p>· {{result.filter_device_type.label || ''}}</p>
                <p>· {{result.filter_type.label || ''}}</p>
              </div>
              <div v-else><p>--</p></div>
            </div>
            <div class="list_item">
              <div class="price_label">消毒设备</div>
              <div v-if="result.disinfect_device.value == 1">
                <p>· {{result.disinfect_device_type.label || ''}}</p>
                <p>· {{result.disinfect_type.label || ''}}</p>
              </div>
              <div v-else><p>--</p></div>
            </div>


            <div class="item_price">
              <span>{{ main_price }}</span>元
            </div>
          </div>

        </div>

        <div class="price_item" v-if="result.constant_device.value == 1">
          <div class="price_list_title flex-c">
            <span>A2</span>
            泳池恒温设备
          </div>
          <div class="price_list">

            <div class="list_item">
              <div class="price_label">增加恒温设备</div>
              <div>
                <p>· {{result.constant_device_type.label || ''}}</p>
                <p>· {{result.constant_device_location.label || ''}}</p>
                <p>· {{result.constant_device_brand.label || ''}}</p>
              </div>
            </div>

            <div class="item_price">
              <span>{{ constant_device_price }}</span>元
            </div>

          </div>

        </div>

        <div class="price_item" v-if="result.dehumidification_device.value == 1">
          <div class="price_list_title flex-c">
            <span>A3</span>
            除湿设备
          </div>
          <div class="price_list">

            <div class="list_item">
              <div class="price_label">增加除湿设备</div>
              <div>
                <p>· {{result.dehumidification_device_type.label || ''}}</p>
                <p>· {{result.dehumidification_device_brand.label || ''}}</p>
              </div>
            </div>

            <div class="item_price">
              <span>{{ dehumidification_device_price }}</span>元
            </div>

          </div>
        </div>
      </div>

    </el-dialog>
    <!-- 报价结果 end-->


  </div>
</template>

<script>
  import footerView from '@/components/footer';
  import radioGroup from '@/components/radio_group';
  import radioSingle from '@/components/radio_single';
  import json from "../utils/json";
  import utils from "../utils/utils";
  export default {
    name: "home",
    //这里存放数据
    data() {
      return {
        classOption: {
          step: 0.5, // 数值越大速度滚动越快
          limitMoveNum: 0, // 开始无缝滚动的数据量
          hoverStop: false, // 是否开启鼠标悬停stop
          direction: 1, // 0向下 1向上 2向左 3向右
          singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
          singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
          waitTime: 1000, // 单步运动停止的时间(默认值1000ms)
          autoPlay: false,
        },
        banner: '',
        aboutImage: require('@/assets/images/image.png'),
        logoImage: require('@/assets/images/logo.png'),
        closeImage: require('@/assets/images/close_white.png'),

        circulateList: [
          {value: '1', title: '逆流循环（过滤效果好）'},
          {value: '2', title: '顺流循环（性价比高）'},
          {value: '3', title: '混合流循环（过滤好+多用途）'},
        ],
        steelsList: [
          {value: '1', title: '国标（热浸锌）'},
          {value: '2', title: '非国标（冷镀锌）'},
        ],
        specList: [
          {value: '1', title: '厚度1.2mm'},
          {value: '2', title: '厚度1.5mm'},
        ],
        brandList: [
          {value: '2', title: '国产优选品牌'},
          {value: '3', title: '国际顶级品牌'},
          {value: '1', title: '国产性价比'},
        ],

        // 过滤设备
        filterDevice: json.filterDevice,
        // 消毒设备
        disinfectDevice: json.disinfectDevice,
        // 恒温设备
        constantDevice: json.constantDevice,
        // 除湿设备
        removeWetDevice: json.removeWetDevice,

        form_type: 2, //1=钢材泳池，2=土建泳池
        form: {
          name: '', //姓名
          mobile: '', //手机号
          long: '', //长
          wide: '', //宽
          deep: '', //水平深度
          gradient_deep: '', //渐变深度
          circulate: {
            value: '2', // 值对应的名称,默认 2=顺流循环
            label: '顺流循环', // 值
          }, //循环方式: 1=逆流循环，2=顺流循环，3=混合流循环
          steels: {
            value: '', //默认：1=国标（热浸锌）
            label: '',
          }, //钢材： 1=国标（热浸锌），2=非国标（冷镀锌）
          coating: {
            spec: '', //规格类型spec : 1:厚度1.2mm 2:厚度1.5mm
            spec_title: '', // 规格名称 默认1:厚度1.2mm
            brand_type: '', // 品牌类型：1:国产性价比 2:国产优先 3:国际顶级
            brand_title: '', // 品牌标题 默认 1:国产性价比
          }, //胶膜
          tz_brand: {
            value: '2',
            label: '国产优先品牌', //2:国产优先品牌 3:国际顶级品牌
          },// 土建的贴砖品牌
          piping_long: '', //管道长
          piping_high: '', //管道高
          piping: {
            brand_type: '1', // 品牌类型：1:国产性价比 2:国产优先 3:国际顶级
            brand_title: '国产性价比', // 品牌标题
          }, //管道类型
          filter_device: {
            value: '1',
            label: '增加过滤设备',
          }, //过滤设备 1=需要过滤， ''=不需要过滤
          filter_device_type: {
            value: '1',
            label: '石英砂（超自来水级过滤）'
          }, //过滤设备类型  1=石英砂,2=硅藻土,3=珍珠岩
          filter_type: {
            value: '2',
            label: '国产优选'
          }, //过滤设备品牌：1=国产性价比 2=国产优先 3=国际顶级

          disinfect_device: {
            value: '1',
            label: '增加消毒设备',
          }, //消毒设备 1=需要消毒， ''=不需要消毒
          disinfect_device_type: {
            value: '5',
            label: '投药桶',
          }, //消毒设备类型: 1=中亚紫外线,2=次氯酸钠,3=铜银离子,4=臭氧消毒,5=投药桶
          disinfect_type: {
            value: '',
            label: '',
          }, //消毒设备品牌: 2=国产优先 3=国际顶级

          constant_device: {
            value: '1',
            label: '增加恒温设备',
          }, //是否要恒温设备: 1=需要恒温， ''=不需要恒温
          constant_device_type: {
            value: '1',
            label: '空气能加热',
          }, //恒温设备类型: 1=空气能加热, 2=燃气锅炉加热
          constant_device_location: {
            value: '3',
            label: '南方',
          }, //恒温设备安装位置: 1=北方,2=中部,3=南方,4=西方
          constant_device_brand: {
            value: '2',
            label: '国产优选',
          }, //恒温设备品牌； 2=国产优选，3=国际顶级

          dehumidification_device: {
            value: '1',
            label: '增加除湿设备',
          }, //是否要除湿设备: 1=需要除湿， ''=不需要除湿
          dehumidification_device_type: {
            value: '1',
            label: '三集一体设备',
          }, //除湿设备类型： 1=三集一体设备，2=顶吸式除湿机，3=落地式除湿机，4=排风扇换气
          dehumidification_device_brand: {
            value: '2',
            label: '国产优选',
          }, // 除湿设备品牌： 1=国产性价比，2=国产优选
        },

        editVisible: false,
        submitLoading: false,
        resultVisible: false,
        result: '',
        result_price: '0.00', //总价
        main_price: '0.00', //池体和过滤价格
        constant_device_price: '0.00', //恒温设备价格
        dehumidification_device_price: '0.00', //除湿设备价格

        disclaimerVisible: false,
        disclaimerContent: '', //免责声明内容
        isAgreement: false, //是否同意免责声明

        quote_list: [],
      };
    },
    //import引入的组件需要注入到对象中才能使用
    components: {
      footerView, radioGroup, radioSingle
    },
    //监听属性 类似于data概念
    computed: {

    },
    //监控data中的数据变化
    watch: {

    },
    //方法集合
    methods: {

      // 是否同意免责声明
      handleAgree(){
        this.isAgreement = !this.isAgreement;
      },

      // 查看免责声明
      lookDisclaimer(){
        this.disclaimerVisible = true;
      },
      handleKnow(){
        this.isAgreement = true;
        this.disclaimerVisible = false;
      },

      editContactInfo(){
        if(this.form.long == '' || this.form.wide == '' || this.form.deep == '' || this.form.gradient_deep == ''){
          this.$message.error("请完善必填项信息");
          return;
        }
        if(this.form_type == 1 && (this.form.deep > 2 || this.form.gradient_deep > 2)){
          this.$message.error('钢结构泳池不建议深度超过两米');
          return;
        }

        if(this.form.circulate.value == ''){
          this.$message.error("请完善必填项信息");
          return;
        }
        this.editVisible = true;
      },

      // 提交报价
      submitQuotation(){
        var that = this;

        if(this.form.name === ''){
          this.$message.error("请填写联系人姓名");
          return;
        }
        if(this.form.mobile === ''){
          this.$message.error("请填写联系人电话");
          return;
        }
        if(!utils.isMobile(this.form.mobile)){
          this.$message.error("手机号格式有误，请重新填写");
          return;
        }

        // 当为土建结构，且 恒温设备安装地区为4(西方)，则清空该数值
        if(this.form_type == 2 && this.form.constant_device_location.value == 4){
          // 恒温设备安装所在地区
          this.form.constant_device_location = {
            value: '',
            label: '',
          }
        }

        if(!this.isAgreement){
          this.$message.error("请阅读并同意免责声明");
          return;
        }

        this.submitLoading = true;
        var param = {
          type: this.form_type,
          ...this.form
        };
        that.$http(that.api.get_price, param, "提交报价").then(res => {
          if (res.code == 1) {
            this.result = res.data.result;
            this.result_price = res.data.price || '0.00';
            this.main_price = res.data.main_price || '0.00';
            this.constant_device_price = res.data.constant_device_price || '0.00';
            this.dehumidification_device_price = res.data.dehumidification_device_price || '0.00';

            setTimeout(()=>{
              this.submitLoading = false;
              this.editVisible = false;
              this.resultVisible = true;
            }, 2000)

          }else{
            this.submitLoading = false;
            this.$message.error(res.msg);
          }
        });
      },


      // 切换是否需要过滤设备
      filterDeviceChange(){
        if(this.form.filter_device.value == 1){
          this.form.filter_device_type = {
            value: '1',
            label: '石英砂（超自来水级过滤）',
          };
          this.form.filter_type = {
            value: '2',
            label: '国产优选',
          };
        }else{
          this.form.filter_device_type = {
            value: '',
            label: '',
          };
          this.form.filter_type = {
            value: '',
            label: '',
          };
        }

      },
      // 切换过滤设备下的类型
      filterDeviceTypeChange(){
        this.form.filter_type = {
          value: '2',
          label: '国产优选',
        };
      },

      // 切换是否需要消毒设备
      disinfectDeviceChange(){
        if(this.form.disinfect_device.value == 1){
          this.form.disinfect_device_type = {
            value: '5',
            label: '投药桶',
          };
          this.form.disinfect_type = {
            value: '',
            label: '',
          };
        }else{
          this.form.disinfect_device_type = {
            value: '',
            label: '',
          };
          this.form.disinfect_type = {
            value: '',
            label: '',
          };
        }

      },
      // 切换消毒设备下的类型
      disinfectDeviceTypeChange(){
        if(this.form.disinfect_device_type.value == 5){
          this.form.disinfect_type = {
            value: '',
            label: '',
          };
        }else{
          this.form.disinfect_type = {
            value: '2',
            label: '国产优选',
          };
        }
      },
      // 切换是否需要恒温设备
      constantDeviceChange(){
        console.log(this.form)
        if(this.form.constant_device.value == 1){
          this.form.constant_device_type = {
            value: '1',
            label: '空气能加热',
          };
          this.form.constant_device_location = {
            value: '1',
            label: '北方',
          };
          this.form.constant_device_brand = {
            value: '2',
            label: '国产优选',
          };
        }else{
          this.form.constant_device_type = {
            value: '',
            label: '',
          };
          this.form.constant_device_location = {
            value: '',
            label: '',
          };
          this.form.constant_device_brand = {
            value: '',
            label: '',
          };
        }

      },
      // 切换除湿回调
      removeWetDeviceChange(type){
        console.log(type)
        if(type == 1){
          if(this.form.dehumidification_device.value == 1){
            this.form.dehumidification_device_type = {
              value: '1',
              label: '三集一体设备',
            };
            this.form.dehumidification_device_brand = {
              value: '2',
              label: '国产优选',
            };
          }else{
            this.form.dehumidification_device_type = {
              value: '',
              label: '',
            };
            this.form.dehumidification_device_brand = {
              value: '',
              label: '',
            };
          }
        }else{
          if(this.form.dehumidification_device_type.value == 1){
            this.form.dehumidification_device_brand = {
              value: '2',
              label: '国产优选',
            };
          }else{
            this.form.dehumidification_device_brand = {
              value: '',
              label: '',
            };
          }
        }
        console.log(JSON.stringify(this.form))

      },


      // 切换报价泳池类型
      changeType(type){
        this.form_type = type;
        this.form.steels = {
          value: type === 1 ? '1' : '', //默认：1=国标（热浸锌）
          label: type === 1 ? '国标（热浸锌）' : '',
        } //钢材： 1=国标（热浸锌），2=非国标（冷镀锌）
        this.form.coating = {
          spec: type === 1 ? '1' : '', //规格类型spec : 1:厚度1.2mm 2:厚度1.5mm
          spec_title: type === 1 ? '厚度1.2mm' : '', // 规格名称
          brand_type: type === 1 ? '1' : '', // 品牌类型：1:国产性价比 2:国产优先 3:国产品牌
          brand_title: type === 1 ? '国产性价比' : '', // 品牌标题
        } //胶膜
        this.form.tz_brand = {
          value: type === 2 ? '2' : '',
          label: type === 2 ? '国产优先品牌' : '', // 2:国产优先品牌 3:国际顶级品牌
        }

      },

      // 获取免责声明
      getDisclaimer(){
        let that = this;
        let param = {};
        that.$http(that.api.disclaimer, param, "获取免责声明").then(res => {
          if (res.code == 1) {
            this.disclaimerContent = res.data.content || '';
          }
        });
      },

      // 获取报价列表
      getQuoteList(){
        let that = this;
        let param = {};
        that.$http(that.api.quoteList, param, "获取报价列表").then(res => {
          if (res.code == 1) {
            this.quote_list = res.data.list || [];
            this.banner = res.data.banner || require('@/assets/images/banner.jpg');
            if(this.quote_list.length > 3){
              this.classOption.autoPlay = true;
            }
          }else{
            this.banner = require('@/assets/images/banner.jpg');
          }
        });
      }

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
      this.getDisclaimer();
      this.getQuoteList();
    },
  }
</script>




// WEBPACK FOOTER //
// src/pages/home.vue